var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Private") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00C86F",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5 C5.33333333,4.66666667 6.33333333,4 7,3 C7.66666667,4 8.66666667,4.66666667 10,5 L10,6.14589803 C10,8.20151331 8.83859819,10.0807009 7,11 L7,11 L7,11 C5.16140181,10.0807009 4,8.20151331 4,6.14589803 L4,5 L4,5 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.effb642f6c15e30eef40b87d1892ea9f.svg";
export { ForwardRef as ReactComponent };